import { useController } from 'react-hook-form';

import ErrorMessage from '@/components/ErrorMessage';
import { cn } from '@/utils';

import Switch from '../Switch';
import Label from './Label';
import { parseMessage } from './utils';

function FormSwitch({
	name,
	label,
	id,
	control,
	disabled,
	required,
	errorMessageProps,
	className,
	...props
}) {
	const { field, fieldState } = useController({ name, control, disabled });

	return (
		<div className={cn('form-input relative w-full', className)}>
			<div className="flex items-center gap-2">
				<Switch
					id={id}
					required={required}
					checked={field.value}
					onCheckedChange={field.onChange}
					{...props}
				/>
				{label && (
					<Label
						htmlFor={id}
						className="mb-0"
					>{`${label}${required ? '*' : ''}`}</Label>
				)}
			</div>
			{fieldState.error?.message && (
				<ErrorMessage {...errorMessageProps}>
					{parseMessage(fieldState.error.message)}
				</ErrorMessage>
			)}
		</div>
	);
}

export default FormSwitch;
